import { TOTAL_SENT_METRIC_LABEL } from '../CampaignsHealthMetrics.constants';

export const METRICS_LOADING_DATA = {
  name: TOTAL_SENT_METRIC_LABEL,
  value: 0,
  data: [],
};
